import React from 'react';
import { ControlledInput } from '@@viewCommonComponents/controlled';

const SimulationNeedsExtraForm = ({ form }) => {

  const isContractOnGoing = form.watch('contractOnGoing');

  return (
    <>
      {isContractOnGoing && (
        <div className="mb-4 row-start-3">
          <ControlledInput
            name="comment"
            label={'Quel est son niveau de garantie ?'}
            form={form}
            errors={form.formState.errors}
            rows={2}
            maxLength={50}
            placeholder="Saisir le niveau de garantie"
            data-testid={'activePoliciesComment'}
          />
        </div>
      )}
    </>
  );
};

export default SimulationNeedsExtraForm;
